import React, { useEffect, useState } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import axios from 'axios';
import { TripCard } from '../components/TripCard';
import RestezInformeCTA from '../components/RestezInformeCTA';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const Trips = () => {
  const [trips, setTrips] = useState([]);
  const [loading, setLoading] = useState(true);
  const [searchParams] = useSearchParams();
  const [filter, setFilter] = useState(searchParams.get('filter') || 'all');
  const [season, setSeason] = useState(searchParams.get('saison') || 'all');

  useEffect(() => {
    const urlFilter = searchParams.get('filter');
    if (urlFilter) {
      setFilter(urlFilter);
    }
    const fetchTrips = async () => {
      try {
        const response = await axios.get(`${API}/trips`);
        const sortedTrips = response.data.sort((a, b) => {
          return new Date(a.start_date) - new Date(b.start_date);
        });
        setTrips(sortedTrips);
        setLoading(false);
      } catch (error) {
        setLoading(false);
      }
    };
    fetchTrips();
  }, [searchParams]);

  const seasons = Array.from(new Set(trips.map(t => (t.start_date || '').slice(0, 4)).filter(Boolean))).sort();
  const filteredTrips = trips.filter(trip => {
    if (season !== 'all' && !(trip.start_date || '').startsWith(season)) return false;
    if (filter === 'all') return true;
    if (filter === 'croisiere') {
      return trip.transport === 'croisiere' || trip.transport === 'avion+croisiere';
    }
    if (filter === 'car') {
      return trip.transport === 'car' || trip.transport === 'autocar';
    }
    return trip.transport === filter;
  });

  return (
    <div className="trips-page">
      {/* Header */}
      <section className="bg-gradient-to-r from-[#79c9ea] to-[#5ba8c8] text-white py-16">
        <div className="container-custom text-center">
          <h1 className="text-3xl sm:text-4xl lg:text-5xl font-bold mb-4 uppercase tracking-wide">NOS VOYAGES {seasons.length ? seasons.join(' - ') : ''}</h1>
          <p className="text-xl opacity-90">Découvrez toutes nos destinations</p>
          <p className="text-sm opacity-70 mt-3 max-w-lg mx-auto italic">
            Ici, on visite des lieux... et on crée aussi des souvenirs.
          </p>
        </div>
      </section>

      {/* Iter 905 (Kamel) — carte des destinations retirée : trop concentrée pour être lisible, elle gênait le défilement */}

      {/* Filters */}
      <section className="section bg-gray-50 py-8">
        <div className="container-custom">
          {seasons.length > 1 && (
            <div className="flex flex-wrap justify-center items-center gap-3 mb-5" data-testid="public-season-filter">
              <span className="text-sm font-bold text-[#1E3A5F]">📅 Saison :</span>
              {['all', ...seasons].map(y => (
                <button key={y} onClick={() => setSeason(y)}
                  className={`px-5 py-2 rounded-full font-bold transition border-2 ${season === y ? 'bg-[#1E3A5F] text-white border-[#1E3A5F]' : y !== 'all' && y > String(new Date().getFullYear()) ? 'bg-amber-50 text-amber-900 border-amber-300 hover:bg-amber-100' : 'bg-white text-gray-700 border-gray-200 hover:bg-gray-100'}`}
                  data-testid={`public-season-${y}`}>
                  {y === 'all' ? 'Toutes' : y === String(new Date().getFullYear()) ? `${y} (en cours)` : `Édition ${y}`}
                  <span className="ml-1 text-xs opacity-60">({y === 'all' ? trips.length : trips.filter(t => (t.start_date || '').startsWith(y)).length})</span>
                </button>
              ))}
            </div>
          )}
          <div className="flex flex-wrap justify-center gap-4">
            <button
              onClick={() => setFilter('all')}
              className={`px-6 py-2 rounded-full font-semibold transition ${
                filter === 'all'
                  ? 'bg-[#5BC5D4] text-white'
                  : 'bg-white text-gray-700 hover:bg-gray-100'
              }`}
            >
              Tous les voyages
            </button>
            <button
              onClick={() => setFilter('avion')}
              className={`px-6 py-2 rounded-full font-semibold transition ${
                filter === 'avion'
                  ? 'bg-[#5BC5D4] text-white'
                  : 'bg-white text-gray-700 hover:bg-gray-100'
              }`}
            >
              ✈️ En avion
            </button>
            <button
              onClick={() => setFilter('car')}
              className={`px-6 py-2 rounded-full font-semibold transition ${
                filter === 'car'
                  ? 'bg-[#5BC5D4] text-white'
                  : 'bg-white text-gray-700 hover:bg-gray-100'
              }`}
            >
              🚌 En autocar
            </button>
          </div>
        </div>
      </section>

      {/* Trips Grid */}
      <section className="section">
        <div className="container-custom">
          {loading ? (
            <div className="flex justify-center py-12">
              <div className="spinner"></div>
            </div>
          ) : (
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
                {filteredTrips.map((trip, index) => (
                  <TripCard key={trip.id} trip={trip} index={index} />
                ))}
              </div>
            )}
          </div>
        </section>

        {/* Restez informé — CTA prospects */}
        <RestezInformeCTA variant="banner" context="trips" />
      </div>
    );
  };

  export default Trips;